import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { DefectPerformanceChartsView } from "src/components/views/spc/defectPerformanceChart/DefectPerormanceChartsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/spc/yieldCharts")({
	staticData: { title: i18n.t("yield_charts"), legacyViewKey: "defectPerformanceChartsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <DefectPerformanceChartsView />;
}
